export default class SubstitutionIsNotValid extends Error {
    constructor() {
        super("Substitution is not valid");
    }
}
